import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "icon"
}

import IconArrowNext from "@/components/icons/IconArrowNext.vue";
import IconArrowPrev from "@/components/icons/IconArrowPrev.vue";
import IconLoader from "@/components/icons/IconLoader.vue";
import IconSend from "@/components/icons/IconSend.vue";

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonButton',
  props: {
    size: {},
    color: {},
    icon: {},
    outlined: { type: Boolean },
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const buttonStyle = computed(() => {
    const styles: string[] = [props.color || "primary", props.size || "medium"];
    if (props.outlined) {
        styles.push("outlined");
    }
    return styles.join(" ");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(buttonStyle.value),
    disabled: __props.disabled || __props.loading
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.icon || __props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (__props.loading)
            ? (_openBlock(), _createBlock(IconLoader, { key: 0 }))
            : (__props.icon == 'next')
              ? (_openBlock(), _createBlock(IconArrowNext, { key: 1 }))
              : (__props.icon == 'prev')
                ? (_openBlock(), _createBlock(IconArrowPrev, { key: 2 }))
                : (__props.icon == 'send')
                  ? (_openBlock(), _createBlock(IconSend, { key: 3 }))
                  : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})